import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';

@Component({
  selector: 'app-useredit',
  templateUrl: './useredit.component.html',
  styleUrls: ['./useredit.component.css']
})
export class UsereditComponent extends BaseComponent implements OnInit {
  guid = '';
  user: any = {id:"",userName:"", firstName:"",organizationId:1,phone:"",lastName:""};
  roles: any = [];
  roleid = 0;
  userroles: any = [];
  resetpassword1 = "";
  resetpassword2 = "";
  passwordverify="";
  organizations: any = [];
  organization: any = {}
  beacons: any = []
  beaconName1 = ""
  beaconName2 = ""
  beaconName3 = ""

  constructor(injector: Injector) {super(injector) }

  async ngOnInit(){
    this.loader.show();
    this.roles = await this.db.get("Role","GetRoles",null);
    this.organizations = await this.db.get("organization","getorganizations")
    this.guid = this.getQueryParameter("id");
    if (this.guid != "0"){
      await this.getData();  
    }else{
      this.user = {id:"",userName:"", firstName:"",organizationId:1,phone:"",lastName:""}
    }
    this.beacons = await this.db.get("Beacon", "getBeacons")
    this.loader.hide();
  }

  async getData(){
    this.user = await this.db.get("Authenticate","GetSingleUser",{id: this.guid});
    this.userroles = await this.db.get("Role","GetUserRoles",{email: this.user.email});
    let a = 5;
  }
  async removeRole(r: any){
    await this.db.delete("Role","removeUserFromRole",{useremail:this.user.userName,rolename: r});
    await this.getData();
  }
  async submit(){
    if (this.user.organizationId == null){
      this.alert.danger("Please select an organization!")
      return
    }
    if (this.user.id == "" && this.checkPassword(this.user.password) == false){
      this.alert.danger("The password must contain at least one of lower case, upper case, number and special character")
      return
    }
    this.loader.show();
    if (this.user.phone.length < 3) this.user.phone="999 999 9999"
    if (this.user.id != ""){
      let userinfo = {id: this.user.id,firstName: this.user.firstName, lastName: this.user.lastName, phone:this.user.phone, OrganizationId: this.user.organizationId}
      await this.db.put("Authenticate","UpdateUserInfo",null,userinfo);
      this.toast.success("User Updated")
    }else{
      this.user.email = this.user.userName;
      this.user = await this.db.post("Authenticate","Register",this.user);
      this.guid = this.user.id;
      await this.getData();
      this.toast.success("User Created")
    }
    this.loader.hide();
  }

  async submitWithOrg(){
    this.loader.show()
    this.organization = {id: 0,name: this.organization.name,abreviation: this.organization.abreviation}
    const resp = await this.db.post("organization", "postorganization", this.organization);
    this.organizations = await this.db.get("organization","getorganizations")
    this.organization = this.organizations.find((x:any) => x.name == this.organization.name)
    this.user.organizationId = this.organization.id
    await this.submit()
    this.loader.hide()
  }
  async changePassword(){
    this.loader.show()
    await this.db.put("Authenticate","ChangePassword",null,{id:this.user.id,password: this.resetpassword1})
    this.toast.success("Password changed")
    this.loader.hide()
  }
  async addRole(){
    let role = this.roles.find((x:any) => x.id == this.roleid);
    await this.db.post("Role","AddRoleToUser",null,{UserEmail: this.user.email,RoleName: role.name})
    await this.getData();
  }
  async delete(){
    await this.db.delete("Authenticate","DeleteUser",{id: this.user.id})
    this.router.navigate(['userlist'])
  }

  checkPassword(password: string): boolean {
    const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/;
    return pattern.test(password);
  }
  async assignBeacon(){
    this.loader.show()
    let beacon1 = this.beacons.find((x:any) => x.name == this.beaconName1)
    let beacon2 = this.beacons.find((x:any) => x.name == this.beaconName2)
    let beacon3 = this.beacons.find((x:any) => x.name == this.beaconName3)

    if (beacon1 == null || beacon2 == null || beacon3 == null){
      this.alert.danger("Could not find all beacons")
      return     
    }
    beacon1.organizationId = this.user.organizationId
    beacon2.organizationId = this.user.organizationId
    beacon3.organizationId = this.user.organizationId

    await this.db.post("Beacon", "postBeacon", beacon1)
    await this.db.post("Beacon", "postBeacon", beacon2)
    await this.db.post("Beacon", "postBeacon", beacon3)
    this.loader.hide()
  }
}
